import { Button } from "primereact/button";
import DatePresetTabs from "@/layouts/AppLayout/DatePresetTabs";
import HierarchyBreadcrumb from "@/layouts/AppLayout/HierarchyBreadcrumb";
import useExportPdf from "@/hooks/useExportPdf";
import { TEXT } from "@/constants/text";
import styles from "@/layouts/AppLayout/TopBar.module.css";

const TopBar = () => {
  const { exportPdf, isExporting } = useExportPdf();

  return (
    <div className={styles.topBar}>
      <HierarchyBreadcrumb />
      <div className={styles.controls}>
        <DatePresetTabs />
        <Button
          data-html2canvas-ignore="true"
          disabled={isExporting}
          icon={isExporting ? "pi pi-spin pi-spinner" : "pi pi-download"}
          label={
            isExporting ? TEXT.topBar.exportingButton : TEXT.topBar.exportButton
          }
          pt={{ root: { className: styles.exportButton } }}
          onClick={exportPdf}
        />
      </div>
    </div>
  );
};

export default TopBar;
